import MainLayout from '@/shared/Layouts/MainLayout'
import css from './employePage.module.css'
import CompletedMaintenanceEventsBlock from './components/CompletedMaintenanceEventsBlock'
import EmployeInfoBlock from './components/EmployeInfoBlock'

import UpcomingMaintenanceEventsBlock from './components/UpcomingMaintenanceEventsBlock'
import userUtils from '@/pages/User/user.utils'
import { useParams } from 'react-router-dom'
import useUser from '@/pages/Users/hooks/useUser'
import Breadcrumbs from '@/navigation/components/NavigationBreadcrumbs'
import IndividualReport from './components/IndividualReport'
import SidePage from '@/shared/SidePage'
import { useState } from 'react'
import EditUserSidePageContent from '@/pages/Users/components/UserSidePage/EditUserSidePageContent'
import Skeleton from '@/shared/Loaders/Skeleton'
import AssignedEquipmentBlock from './components/AssignedEquipmentBlock'
import useTitle from '@/shared/hooks/useTitle'

const EmployePage = () => {
  const userId = useParams().id
  const { user, loading } = useUser(+userId)
  const [openUserSidePage, setOpenUserSidePage] = useState(false)
  useTitle(user ? `Сотрудник — ${userUtils.getFullName(user.userInfo)}` : 'Сотрудник')

  const renderBreadcrumbs = () => {
    if (loading) return <Skeleton style={{ borderRadius: '8px' }} height="32px" width="460px" />

    return (
      <Breadcrumbs
        withBackButton={true}
        lastMatch={{
          pathname: '/',
          handle: {
            canNavigate: false,
            crumb: () => userUtils.getFullName(user.userInfo),
          },
          id: user.id.toString(),
        }}
      />
    )
  }

  return (
    <>
      <MainLayout>
        <div className={css.wrapper}>
          <div className="flex-lines gap16 height100">
            {renderBreadcrumbs()}
            <div className={css.container}>
              <EmployeInfoBlock user={user} loading={loading} onEmployeEditClick={() => setOpenUserSidePage(true)} />
              <IndividualReport user={user} loading={loading} />
              <UpcomingMaintenanceEventsBlock user={user} loading={loading} />
              <AssignedEquipmentBlock user={user} loading={loading} />
              <CompletedMaintenanceEventsBlock user={user} loading={loading} />
            </div>
          </div>
        </div>
      </MainLayout>
      {user && (
        <SidePage onClose={() => setOpenUserSidePage(false)} open={openUserSidePage}>
          <EditUserSidePageContent user={user} onCancel={() => setOpenUserSidePage(false)} />
        </SidePage>
      )}
    </>
  )
}

export default EmployePage
